import type { ReactNode } from "react";
import { RhythmicDictationInput } from "@music-app/ui-components";
import type { RhythmicDictationGrading } from "@music-app/exercise-generator";
import type { ExerciseRendererProps } from "./types.js";

export function RhythmicRenderer({
  exercise,
  pendingAnswer,
  gradingResult,
  disabled,
  onAnswerChange,
  onSubmit,
}: ExerciseRendererProps): ReactNode {
  const meter = exercise.meta.rhythmMeter ?? "4/4";
  const cellCount = exercise.meta.expectedPattern?.length ?? (meter === "6/8" ? 6 : 8);
  const rawGrid = pendingAnswer?.type === "rhythmic" ? pendingAnswer.grid : [];
  const grid = rawGrid.length === cellCount ? rawGrid : Array<boolean>(cellCount).fill(false);
  const graded = gradingResult !== null;
  const rhythmicGrading = gradingResult?.detail as RhythmicDictationGrading | null | undefined;

  return (
    <div>
      <RhythmicDictationInput
        meter={meter}
        grid={grid}
        onChange={(next) => onAnswerChange({ type: "rhythmic", grid: next })}
        cellStatuses={graded ? rhythmicGrading?.cellStatuses : undefined}
        disabled={disabled}
      />
      {!graded && (
        <div className="mt-4">
          <button
            type="button"
            onClick={() => onSubmit({ type: "rhythmic", grid })}
            className="bg-ink text-paper px-[18px] py-3 font-sans text-sm font-medium hover:bg-accentSoft transition-colors"
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
}
